import { render, staticRenderFns } from "./ReMarketingHistory.vue?vue&type=template&id=102158a8&scoped=true"
import script from "./ReMarketingHistory.vue?vue&type=script&lang=js"
export * from "./ReMarketingHistory.vue?vue&type=script&lang=js"
import style0 from "./ReMarketingHistory.vue?vue&type=style&index=0&id=102158a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "102158a8",
  null
  
)

export default component.exports